(function() { window.GUID_53c764b1_2eb7_4d13_8607_a549e99c2bb8 = { getGuid: function() { return "53c764b1-2eb7-4d13-8607-a549e99c2bb8"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    class QuickTournamentsSection {
                        static get instance() {
                            if (!QuickTournamentsSection._instance)
                                QuickTournamentsSection._instance = new QuickTournamentsSection();
                            return QuickTournamentsSection._instance;
                        }
                        constructor() { }
                        static RemoveQuickTournament(quickTournamentId, $quickTournament) {
                            CS.Ajax.Post(CS.Url.CSUrl("deletequicktournament"), { quickTournamentId }, () => {
                                if ($quickTournament.length) {
                                    $quickTournament.slideUp();
                                }
                            });
                        }
                    }
                    WallSections.QuickTournamentsSection = QuickTournamentsSection;
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=quick-tournaments-section.js.map
